import LegalPage from "../components/LegalPage";

const TOC = [
  { id: "uso", label: "Uso de la plataforma" },
  { id: "cuentas", label: "Creación de cuentas" },
  { id: "suscripciones", label: "Suscripciones" },
  { id: "pagos", label: "Pagos" },
  { id: "facturacion", label: "Facturación" },
  { id: "responsabilidades", label: "Responsabilidades del usuario" },
  { id: "propiedad", label: "Propiedad intelectual" },
  { id: "cancelaciones", label: "Cancelaciones" },
  { id: "suspension", label: "Suspensión de cuentas" },
  { id: "limitacion", label: "Limitación de responsabilidad" },
  { id: "legislacion", label: "Legislación aplicable" },
  { id: "contacto", label: "Contacto" },
];

export default function TermsPage() {
  return (
    <LegalPage title="Términos y Condiciones" toc={TOC} testid="terms-page">
      <p className="legal-lede">
        Al utilizar Mi Contador, aceptas los siguientes términos que rigen tu relación con la plataforma. Léelos cuidadosamente.
      </p>

      <section id="uso">
        <h2>1. Uso de la plataforma</h2>
        <p>Mi Contador es una herramienta digital que ayuda a organizar información fiscal y financiera. El usuario acepta utilizarla únicamente para fines lícitos y de acuerdo con estos términos.</p>
      </section>

      <section id="cuentas">
        <h2>2. Creación de cuentas</h2>
        <p>Para acceder a la plataforma, el usuario debe crear una cuenta proporcionando información veraz. El usuario es responsable de mantener la confidencialidad de sus credenciales y de toda actividad que ocurra bajo su cuenta.</p>
      </section>

      <section id="suscripciones">
        <h2>3. Suscripciones</h2>
        <p>Mi Contador puede ofrecer planes gratuitos y de pago. Las funcionalidades disponibles dependen del plan contratado. Los precios y beneficios pueden cambiar con aviso previo.</p>
      </section>

      <section id="pagos">
        <h2>4. Pagos</h2>
        <p>Los pagos se procesan mediante proveedores externos (por ejemplo, Stripe). Al suscribirte, aceptas los términos del proveedor de pagos. No almacenamos los datos completos de tarjetas.</p>
      </section>

      <section id="facturacion">
        <h2>5. Facturación</h2>
        <p>Mi Contador permite preparar y timbrar CFDI a través de proveedores autorizados por el SAT. El usuario es responsable de la veracidad de la información fiscal utilizada.</p>
      </section>

      <section id="responsabilidades">
        <h2>6. Responsabilidades del usuario</h2>
        <ul>
          <li>Mantener actualizada la información fiscal.</li>
          <li>No compartir credenciales con terceros.</li>
          <li>Utilizar la plataforma conforme a la ley mexicana.</li>
          <li>No intentar vulnerar la seguridad ni acceder a información de otros usuarios.</li>
        </ul>
      </section>

      <section id="propiedad">
        <h2>7. Propiedad intelectual</h2>
        <p>La marca, código, diseños y contenidos de Mi Contador son propiedad de sus titulares. El usuario recibe una licencia limitada, no exclusiva y revocable para utilizar la plataforma.</p>
      </section>

      <section id="cancelaciones">
        <h2>8. Cancelaciones</h2>
        <p>El usuario puede cancelar su suscripción en cualquier momento desde su perfil. La cancelación surte efecto al final del período pagado y no genera reembolsos salvo obligación legal.</p>
      </section>

      <section id="suspension">
        <h2>9. Suspensión de cuentas</h2>
        <p>Mi Contador podrá suspender o cancelar cuentas que incumplan estos términos, presenten actividad fraudulenta o pongan en riesgo la operación de la plataforma.</p>
      </section>

      <section id="limitacion">
        <h2>10. Limitación de responsabilidad</h2>
        <p>Mi Contador es una herramienta de apoyo y no reemplaza la asesoría profesional contable o legal. La plataforma se ofrece "tal cual", sin garantías implícitas más allá de las requeridas por ley.</p>
      </section>

      <section id="legislacion">
        <h2>11. Legislación aplicable</h2>
        <p>Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier controversia se someterá a los tribunales competentes de la Ciudad de México, renunciando a cualquier otro fuero.</p>
      </section>

      <section id="contacto">
        <h2>12. Contacto</h2>
        <p>Para dudas sobre estos términos: <a href="mailto:legal@micontador.com">legal@micontador.com</a></p>
      </section>
    </LegalPage>
  );
}
